'use strict';

var izettle = angular.module('gymsystem.izettle', []);

izettle.factory('iosBridge', ['$rootScope', function($rootScope) {
    var iosBridge = {};

    var connectWebViewJavascriptBridge = function(callback) {
        if (window.WebViewJavascriptBridge) {
            callback(WebViewJavascriptBridge);
        } else {
            document.addEventListener('WebViewJavascriptBridgeReady', function() {
                callback(WebViewJavascriptBridge);
            }, false);
        }
    };

    var init = function() {
        connectWebViewJavascriptBridge(function(bridge) {
            bridge.init(function(message, responseCallback) {
                responseCallback('ok');
            });

            iosBridge.callHandler = function(name, data, callback) {
                bridge.callHandler(name, data, function(result) {
                    $rootScope.$apply(function() {
                        callback(result);
                    });
                });
            };
        });
    };

    // FIXME: Calls before initialized...?

    init();

    return iosBridge;
}]);

izettle.factory('izettle', ['iosBridge', function(iosBridge) {
    var izettle = {};

    izettle.isReady = function() {
        return iosBridge.callHandler;
    };

    izettle.pay = function(amount, transaction_id, success, error) {
        if (!iosBridge.callHandler) {
            error();
            return;
        }

        iosBridge.callHandler('charge', {amount: String(amount), transaction_id: transaction_id}, function(result) {
            if (result == 'success') {
                success();
            } else {
                error();
            }
        });
    };

    return izettle;
}]);
